import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { createTheme, makeStyles } from '@material-ui/core/styles';
import { grey, red } from '@material-ui/core/colors';

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`;

export const Buttons = styled(Button)`
  background-color: #FFA500;
  border: 1px;
  border-color:  #FFA500;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 10px 0px;
  &:hover {
    background-color: #FFA500;
    border-color:  #FFA500;
  }
}
`;

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '10px',
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: '200px',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  tableActionButtonIcon: {
    width: '20px',
    height: '20px'
  },
  popover: {
    width: '100%',
    marginTop: '15px'
  },
  paper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
}));

export const theme = createTheme({
  typography: {
    fontFamily: [
      'Nunito',
    ].join(','),
  },
  palette: {
    secondary: {
      main: grey[500],
      dark: red[500],
    },
    primary: {
      main: '#43a047',
    },
  },
});

